import * as React from "react";
const SvgFiRrMicrophoneSlash = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-microphone-slash_svg__a)">
      <path
        fill="#062147"
        d="M6 11v1a6.006 6.006 0 0 0 6.86 5.94 1 1 0 1 1 .281 1.981 8 8 0 0 1-1.142.08c-4.41 0-8-3.589-8-8v-1a1 1 0 0 1 2 0zm17.707 11.293a.999.999 0 1 1-1.414 1.414l-22-22A.999.999 0 1 1 1.707.293l3.49 3.49A7.96 7.96 0 0 1 12 0c4.411 0 8 3.59 8 8v4a7.95 7.95 0 0 1-1.68 4.906l1.423 1.423A9.96 9.96 0 0 0 22 12a1 1 0 0 1 2 0c0 2.857-1.003 5.583-2.837 7.748zM6.665 5.25l10.226 10.226A5.94 5.94 0 0 0 17.917 13H15a1 1 0 0 1 0-2h3V9h-3a1 1 0 0 1 0-2h2.916A6.01 6.01 0 0 0 12 2 5.97 5.97 0 0 0 6.665 5.25m9.507 15.841a9.9 9.9 0 0 1-4.17.91c-5.515 0-10-4.487-10-10a1 1 0 0 0-2 0c0 6.616 5.382 12 12 12a11.9 11.9 0 0 0 5.005-1.092 1 1 0 0 0-.835-1.818"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-microphone-slash_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMicrophoneSlash;
